import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Plane, Timer } from 'lucide-react';

const Dokumenty = () => {
  const dokumenty = [
    {
      id: 'wniosek-urlopowy',
      title: 'Wniosek Urlopowy',
      description: 'Złóż wniosek o urlop wypoczynkowy, okolicznościowy lub bezpłatny',
      icon: Calendar,
      href: '/kadry/dokumenty/wniosek-urlopowy',
      color: 'blue'
    },
    {
      id: 'wniosek-delegacyjny',
      title: 'Wniosek Delegacyjny',
      description: 'Złóż wniosek o wyjazd służbowy (delegację)',
      icon: Plane,
      href: '/kadry/dokumenty/wniosek-delegacyjny',
      color: 'green'
    },
    {
      id: 'wniosek-nadgodziny',
      title: 'Wniosek o nadgodziny',
      description: 'Uzyskaj zgodę przełożonego na pracę w godzinach nadliczbowych przed jej rozpoczęciem',
      icon: Timer,
      href: '/nadgodziny/wniosek',
      color: 'amber'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Dokumenty List */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {dokumenty.map((dokument) => {
          const Icon = dokument.icon;
          const colorClasses = {
            blue: 'bg-blue-100 text-blue-600 hover:bg-blue-200 border-blue-300',
            green: 'bg-green-100 text-green-600 hover:bg-green-200 border-green-300',
            amber: 'bg-amber-100 text-amber-600 hover:bg-amber-200 border-amber-300'
          };

          return (
            <Link
              key={dokument.id}
              to={dokument.href}
              className={`bg-white shadow rounded-lg p-6 border-2 ${colorClasses[dokument.color]} transition-all hover:shadow-lg cursor-pointer`}
            >
              <div className="flex items-start space-x-4">
                <div className={`flex-shrink-0 p-3 rounded-lg ${colorClasses[dokument.color]}`}>
                  <Icon className="h-8 w-8" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {dokument.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {dokument.description}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Dokumenty;

